/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Pagina zonder naam',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description':
    'Maak een nieuwe pagina aan en voeg deze in als link',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence-pagina aanmaken',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Openen in Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Je pagina is aangemaakt',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Pagina aangemaakt',
  'editorExtensionLinkCreate.confluencePage.title': 'Nieuwe pagina aanmaken',
  'editorExtensionLinkCreate.genericError.description': 'Vernieuw de pagina en probeer het opnieuw.',
  'editorExtensionLinkCreate.genericError.title': 'Er is iets misgegaan',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Maak inline een issue aan en voeg de issue in als link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Maak inline een werkitem aan en voeg het werkitem in als link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira-issue aanmaken',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Jira-werkitem aanmaken',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Openen in Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Je issue is aangemaakt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4':
    'Je werkitem is aangemaakt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Issue aangemaakt',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Werkitem aangemaakt',
  'editorExtensionLinkCreate.jiraIssue.title': 'Nieuw issue aanmaken',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Nieuw werkitem aanmaken',
  'editorExtensionLinkCreate.keyword.create': 'aanmaken',
  'editorExtensionLinkCreate.keyword.issue': 'Werkitem',
  'editorExtensionLinkCreate.keyword.new': 'nieuw',
  'editorExtensionLinkCreate.keyword.page': 'pagina',
  'editorExtensionLinkCreate.keyword.publish': 'publiceren',
  'editorExtensionLinkCreate.keyword.raise': 'indienen',
  'editorExtensionLinkCreate.keyword.space': 'space',
  'editorExtensionLinkCreate.keyword.ticket': 'ticket',
};
